import { render, staticRenderFns } from "./ConsecutivePreferences.vue?vue&type=template&id=08ffbee5&"
import script from "./ConsecutivePreferences.vue?vue&type=script&lang=ts&"
export * from "./ConsecutivePreferences.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports